<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="SpO2"
      :label="$t('kiosk.oximetry')"
      label-for="SpO2"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.oximetry')"
        rules="required|between:40,100"
        #default="{ errors }"
      >
        <b-input-group
          append="%"
          class="input-group-merge"
        >
          <b-form-input
            id="SpO2"
            :value="form.SpO2"
            @input="v => { form.SpO2 = v; emitFormData() }"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";

export default {
  name: "NwFormBo",
  mixins: [nwFormTaskTypeMixin],
}
</script>

<style scoped>

</style>